import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { SidebarModule } from 'primeng/sidebar';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ChipsModule } from 'primeng/chips';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { PaginatorModule } from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmationService } from 'primeng/api';
import { AiComposerComponent } from './ai-composer.component';

@NgModule({
  declarations: [AiComposerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TableModule,
    SidebarModule,
    MultiSelectModule,
    ListboxModule,
    AutoCompleteModule,
    InputTextModule,
    InputTextareaModule,
    ChipsModule,
    CheckboxModule,
    ConfirmDialogModule,
    TabViewModule,
    TooltipModule,
    PaginatorModule,
    DropdownModule,
  ],
  exports: [AiComposerComponent],
  providers: [ConfirmationService],
})
export class AiComposerModule {}

